import React from 'react'

const TicketCreation = () => {
  return (
    <div>TicketCreation</div>
  )
}

export default TicketCreation